/**
 * Hydration gate — pose la classe `.hydrated` sur #root après le 1er render.
 *
 * Pourquoi : `scripts/prerender.ts` injecte la variante HomeReglette
 * (par défaut) dans dist/index.html au build pour le SEO. createRoot() fait
 * ensuite un rendu COMPLET côté client (pas une hydratation) — si l'API
 * /home-variant retourne une autre variante, le DOM est intégralement
 * remplacé et l'utilisateur voit un flash.
 *
 * La règle CSS dans `styles/index.css` cache #root tant que .hydrated
 * n'est pas posée. On la pose après le 1er commit React (= 1er render
 * effectif), ce qui :
 *  - élimine le flash (le contenu pré-rendu reste caché jusqu'à ce que
 *    React soit prêt à l'écraser avec la vraie variante) ;
 *  - préserve le SEO (Googlebot lit le HTML pré-rendu avant que le JS
 *    ne s'exécute, donc il voit le contenu indépendamment de .hydrated) ;
 *  - n'induit pas de CLS (visibility, pas display:none).
 *
 * Fallback : si le bundle ne charge jamais, le contenu pré-rendu reste
 * hidden pour toujours. Le <noscript> dans index.html doit donc override
 * ce comportement pour exposer le contenu SEO aux crawlers no-JS.
 */
import { useEffect } from "react";

export function HydrationGate(): null {
  useEffect(() => {
    const root = document.getElementById("root");
    if (root) {
      root.classList.add("hydrated");
    }
  }, []);
  return null;
}
